// @flow
import BaseComponent from '../base_component/base_component'
import componentLocator from '../../assets/javascripts/component_locator'

export default class SearchBar extends BaseComponent {
    filtersActive: boolean
    previousSearch: Array<string>
    target: any

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);

        this.find('.quick-search-input').keyup(() => this.handleSearch());
        this.previousSearch = [];
        if (options.target) {
            componentLocator.getSingle(options.target).then(c => {
                this.target = c.functions()
            });
        } else {
            this.target = componentLocator.f; // All searchables.
        }
    }
    
    handleSearch() {
        let $searchBar = this.find('.quick-search-input');

        let text: any = ($searchBar.val() || '');
        if (text) {
            this.target.removeSearch();
            (text || '').split(' ').forEach(word => {
                this.target.addSearch(word)
            });
        } else {
            this.target.removeSearch();
        }
    }
}